// extracted by mini-css-extract-plugin
export var blue = "#0eb3f2";
export var container = "TextArea-module--container--d087d";
export var disabled = "TextArea-module--disabled--9df2f";
export var emphasis = "TextArea-module--emphasis--492e2";
export var focus = "TextArea-module--focus--dac2b";
export var green = "#57d33b";
export var greenLink = "TextArea-module--green-link--9fcc8";
export var grey = "var(--tone-mid)";
export var hasError = "TextArea-module--hasError--d55e9";
export var hasIcon = "TextArea-module--hasIcon--dde48";
export var hasPrefixIcon = "TextArea-module--hasPrefixIcon--0fb30";
export var icon = "TextArea-module--icon--9e636";
export var label = "TextArea-module--label--ffdad";
export var noSpacing = "TextArea-module--noSpacing--b30ac";
export var notchGap = "32px";
export var orange = "#f8662b";
export var prefixIcon = "TextArea-module--prefixIcon--c4cad";
export var red = "#ff2741";
export var textArea = "TextArea-module--textArea--c606b";
export var textAreaWrapper = "TextArea-module--textAreaWrapper--69df0";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";